{
    "raporsatiskalangun": {
        "Baslik": "Sales Remaining Days Report",
        "PoliceNo": "Policy No",
        "Musteri": "Customer",
        "Urun": "Product",
        "Kullanici": "User",
        "KalanGun": "Remaining Days",
        "VadeTarihi": "Due Date",
        "OdemeSekli": "Payment Type",
        "Ara": "Filter",
        "A1": "Monthly (< 7 Days)",
        "A3": "Quarterly (< 15 Days)",
        "A6": "Six Monthly (< 23 Days)",
        "A12": "Yearly (< 31 Days)",
        "Kapsam": "Scope"
    }
}
